module.exports = __webpack_public_path__ + "static/media/Kreuzgang.80929b45.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Kreuzgang.JPG
// module id = 761
// module chunks = 0